import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Panel } from 'primereact/panel';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { intlShape } from '../../../components/prop-types';


const i18n = defineMessages({
  header: {
    id: 'actions.delete',
    defaultMessage: 'Delete',
  },
});


const SuperLinkDeleteImport = (props) => {
  const {
    reject,
    confirm,
    modalOpen,
    intl: { formatMessage },
  } = props;

  const headerMessage = formatMessage(i18n.header);


  const dialogFooter = (
    <Fragment>
      <FormattedMessage id="actions.cancel" defaultMessage="Cancel">
        {text => (
          <Button
            className="p-button-secondary"
            label={text}
            onClick={reject}
          />
        )}
      </FormattedMessage>
      &nbsp;
      <FormattedMessage id="actions.delete" defaultMessage="Delete">
        {text => (
          <Button
            label={text}
            type="button"
            onClick={confirm}
            className="p-button-danger"
          />
        )}
      </FormattedMessage>
    </Fragment>
  );
  return (
    <Dialog
      header={headerMessage}
      footer={dialogFooter}
      visible={modalOpen}
      onHide={reject}
      modal
    >
      <Panel>
        <div className="p-grid p-fluid">
          <div className="p-col">
            <FormattedMessage
              id="file_import.mes.cofirm_remove_status"
              defaultMessage="Clicking OK will remove the Import File you have selected"
            />
          </div>
        </div>
      </Panel>
    </Dialog>
  );
};

SuperLinkDeleteImport.propTypes = {
  reject: PropTypes.func.isRequired,
  confirm: PropTypes.func.isRequired,
  modalOpen: PropTypes.bool.isRequired,
  intl: intlShape.isRequired,
};

export default withRouter(injectIntl(SuperLinkDeleteImport));
